import { getToken, getStore, setStore, removeStore } from "@/utils/auth";
// import { debounce } from "@/utils/debounce";
import { upload } from "@/api/login";
import CityOption from "@/static/js/city3";
import AreaOption from "@/static/js/cityArea";
import Empty from "@/components/Empty";
import {
  bidFocus,
  unbidFocus,
  techCollect,
  unTechCollect,
  vipCollect,
  unVipCollect,
  actionCollect,
  unActionCollect,
  policyCollect,
  unPolicyCollect,
  rewardCollect,
  unRewardCollect,
} from "@/api/Collect/Collect";

let MIXIN = {
  components: {
    Empty,
  },
  data() {
    // const now = new Date();
    // const future = new Date(now.getFullYear() + 3, 11, 31);
    return {
      imgApi: process.env.VUE_APP_BASE_IMAGE,
      routerName: "",
      userInfo: {},
      cityOptions: [],
      areaOptions: [],
      greyList: ['/ArtbuyingDetail', '/ArtistDetail', '/ArtworkPeripheryDetail', '/NewsDetail', '/ArtistList', '/Example'],
    };
  },
  watch: {
    $route(newValue) {
      if (newValue) {
        // console.log(newValue);
        this.routerName = newValue.name;
      }
    },
  },
  created() {
    if (this.$route) {
      this.routerName = this.$route.name;
    }
    this.getCityOptions();
    // console.log(now);
  },
  mounted() { },
  methods: {
    // handleTouchStart(event) {
    //   event.preventDefault(); // 阻止默认的触摸行为
    //   event.stopPropagation();
    // },
    // handleTouchMove(event) {
    //   event.preventDefault(); // 阻止默认的滑动行为
    //   event.stopPropagation();
    // },
    scrollRecord(ref, routerName) {
      // console.log(this.$refs[ref].$el);
      let recordData = {}
      if (ref === 'Home') {
        recordData = {
          name: routerName,
          scroll: document.documentElement.scrollTop
        }
      } else {
        // 记录id
        recordData = {
          name: routerName,
          scroll: this.$refs[ref].$el.scrollTop
        }
      }
      console.log(recordData);
      setStore('ScrollRecord', recordData)
    },
    getScroll(ref, routerName) {
      let recordData = JSON.parse(getStore('ScrollRecord')) || {}
      console.log('ScrollRecord', recordData);
      if (recordData.name) {
        if (recordData.name === routerName) {
          if (ref === "Home") {
            // console.log('走到这里');
            // document.documentElement.scrollTop =recordData.scroll
            setTimeout(() => {
              // console.log('滚动到', document.documentElement.scrollTop);
              // console.log('滚动到', recordData.scroll);
              let scroll = 0
              if (recordData.scroll > document.documentElement.scrollTop) {
                scroll = recordData.scroll - document.documentElement.scrollTop
              } else {
                scroll = document.documentElement.scrollTop - recordData.scroll
              }
              window.scrollBy(0, scroll)
            }, 100)
          } else {
            this.$refs[ref].$el.scrollTop = recordData.scroll
          }
        }
      }
      removeStore('ScrollRecord')
    },
    adClick(item) {
      switch (item.detailType) {
        case 1:
          // 富文本
          this.linkJump('/RichText', { id: item.id })
          break;
        case 2:
          // 链接
          this.openWindow(item.linkUrl)
          break;
        default:
          break;
      }
    },
    toProtocol(code) {
      window.open(process.env.VUE_APP_PROTOCOL_URL + "?code=" + code);
    },
    toOpinion() {
      window.open(process.env.VUE_APP_YIJIAN_URL);
    },
    toBusiness() {
      // 去商家端
      window.open(process.env.VUE_APP_BUSINESS_URL);
    },
    getUserInfo() {
      // 从localStorage中取userInfo
      let userInfoStr = getStore("userInfo");
      if (userInfoStr) {
        this.userInfo = JSON.parse(userInfoStr);
      } else {
        this.userInfo = {};
      }
    },
    // toLogin(){
    //   // 记录当前页跳转登录
    //   console.log(this.$route);

    //   this.$router.push("/login");
    // },
    downloadFile(item) {
      window.open(process.env.VUE_APP_BASE_IMAGE + item.fileurl, '_blank', 'download=' + item.filename)
      // 下载
      this.$message({
        message: "下载中",
        type: "success"
      });
    },
    openWindow(link) {
      // 打开新窗口
      window.open(link);
    },
    // 关注竞价/取消关注竞价
    async toCollection(key, detail) {
      if (getToken()) {
        let res = {};
        switch (key) {
          case "Outcome":
            // 成果收藏
            if (detail.isCollect === 1) {
              res = await unTechCollect({ id: detail.id });
              this.$message({
                message: "取消收藏成功",
                type: "success",
              });
            } else {
              res = await techCollect({ id: detail.id });
              this.$message({
                message: "收藏成功",
                type: "success",
              });
            }
            break;
          case "Vip":
            // 会员收藏
            if (detail.isCollect === 1) {
              res = await unVipCollect({ id: detail.id });
              this.$message({
                message: "取消收藏成功",
                type: "success",
              });
            } else {
              res = await vipCollect({ id: detail.id });
              this.$message({
                message: "收藏成功",
                type: "success",
              });
            }
            break;
          case "Activity":
            // 活动收藏
            if (detail.isCollect === 1) {
              res = await unActionCollect({ id: detail.id });
              this.$message({
                message: "取消收藏成功",
                type: "success",
              });
            } else {
              res = await actionCollect({ id: detail.id });
              this.$message({
                message: "收藏成功",
                type: "success",
              });
            }
            break;
          case "Policy":
            // 政策收藏
            if (detail.isCollect === 1) {
              res = await unPolicyCollect({ id: detail.id });
              this.$message({
                message: "取消收藏成功",
                type: "success",
              });
            } else {
              res = await policyCollect({ id: detail.id });
              this.$message({
                message: "收藏成功",
                type: "success",
              });
            }
            break;
          case "Reward":
            // 技术悬赏收藏
            if (detail.isCollect === 1) {
              res = await unRewardCollect({ id: detail.id });
              this.$message({
                message: "取消收藏成功",
                type: "success",
              });
            } else {
              res = await rewardCollect({ id: detail.id });
              this.$message({
                message: "收藏成功",
                type: "success",
              });
            }
            break;
          case "Competitive":
            // 竞价关注
            console.log(detail);
            console.log(detail.isFocus);
            if (detail.isFocus === 1) {
              res = await unbidFocus({ bidId: detail.id });
              this.$message({
                message: "取消关注成功",
                type: "success",
              });
            } else {
              res = await bidFocus({ bidId: detail.id });
              this.$EventBus.$emit("getPageRecords");
              this.$message({
                message: "关注成功",
                type: "success",
              });
            }
            this.$EventBus.$emit("getDetail");
            break;

          default:
            break;
        }

        // 更新CompetitiveDetail
        console.log(res);
        this.$EventBus.$emit("getDetail");
      } else {
        this.$router.replace("/login");
        // this.toRightPath("/login");
        setStore("urlRecord", this.$route.fullPath);
        // this.$EventBus.$emit('childByValue',true)
      }
    },

    // 取消收藏
    async toUnfavorite(key, detail) {
      if (getToken()) {
        let res = {};
        switch (key) {
          case "Outcome":
            // 成果收藏
            res = await unTechCollect({ id: detail.id });
            this.$message({
              message: "取消收藏成功",
              type: "success",
            });
            break;
          case "Vip":
            // 会员收藏
            res = await unVipCollect({ id: detail.id });
            this.$message({
              message: "取消收藏成功",
              type: "success",
            });
            break;
          case "Activity":
            // 活动收藏
            res = await unActionCollect({ id: detail.id });
            this.$message({
              message: "取消收藏成功",
              type: "success",
            });
            break;
          case "Policy":
            // 政策收藏
            res = await unPolicyCollect({ id: detail.id });
            this.$message({
              message: "取消收藏成功",
              type: "success",
            });
            break;
          case "Reward":
            // 技术悬赏收藏
            res = await unRewardCollect({ id: detail.id });
            this.$message({
              message: "取消收藏成功",
              type: "success",
            });
            break;
          default:
            break;
        }

        // 更新CompetitiveDetail
        console.log(res);
        this.$EventBus.$emit("getDetail");
      } else {
        this.toRightPath("/login");
        setStore("urlRecord", this.$route.fullPath);
        // this.$EventBus.$emit('childByValue',true)
      }
    },
    getCityOptions() {
      AreaOption.map((item) => {
        item.value = item.label;
        item.children.map((i) => {
          i.value = i.label;
          if (i.children) {
            i.children.map((k) => {
              k.value = k.label;
            });
          }
        });
      });
      CityOption.map((item) => {
        item.value = item.label;
        item.children.map((i) => {
          i.value = i.label;
          delete i.children;
        });
      });
      this.areaOptions = AreaOption;
      this.cityOptions = CityOption;
    },
    // debounce,
    async singleUpload(formData) {
      const { data } = await upload(formData);
      return data;
    },
    toRightPath(path) {
      let urlRecord = getStore("urlRecord");
      if (!urlRecord) {
        console.log("toRightPath");
        this.$router.replace({ path });
      } else {
        removeStore("urlRecord");
        this.$router.replace({ path: urlRecord });
      }
    },
    isMobile() {
      const regex = /mobile|android|iphone|ipad|ipod|blackberry|windows phone|Mac OS X.*Version/i;
      console.log(regex.test(navigator.userAgent))
      return regex.test(navigator.userAgent);
    },

    linkJump(type, link, params = {}, ref, routerName) {
      console.log(type, link, params, ref, routerName);
      if (type === 1) {
        if (!this.isMobile()) {
          let routeData = this.$router.resolve({
            path: link,
            query: params,
          });
          console.log("111", routeData);
          window.open(routeData.href);
        } else {
          let routeData = this.$router.resolve({
            path: link,
            query: params,
          });
          console.log("手机跳页1", routeData);
          this.$router.push({
            path: link,
            query: params,
          });
          if (this.greyList.includes(link)) {
            document.documentElement.scrollTop = document.body.scrollTop = 0;
          }
        }
      } else {
        console.log(ref, routerName);
        if (!ref && !routerName) {
          this.$router.push({
            path: link,
            query: params,
          });
        } else {
          this.scrollRecord(ref, routerName)
          let routeData = this.$router.resolve({
            path: link,
            query: params,
          });
          console.log("手机跳页2", routeData);
          console.log("记录scrollbar滚动位置", document.body.scrollTop);
          this.$router.push({
            path: link,
            query: params,
          });
        }
      }
    },
    toRouterPush(path, query = {}, scroll) {
      document.documentElement.scrollTop = document.body.scrollTop = scroll;
      this.$router.push({
        path,
        query,
      });
    },

    handleVisiable(e) {
      // 监听页面离开事件
      if (e.target.visibilityState === "visible") {
        console.log("回来了,刷新列表");
        this.onRefresh();
      } else {
        console.log("离开了");
      }
    },
    // 裁剪取消
    canceltailor() {
      this.fileList = [];
    },

    // 校验全屏状态
    checkFull() {
      var isFull =
        document.fullscreenEnabled ||
        window.fullScreen ||
        document.webkitIsFullScreen ||
        document.msFullscreenEnabled;
      if (isFull === undefined) isFull = false;
      return isFull;
    },
    SplitArray(N, Q) {
      let R = [],
        F;
      for (F = 0; F < Q.length;) R.push(Q.slice(F, (F += N)));
      return R;
    },
  },
};
export default MIXIN;
